export type VolumePage = {
  src: string
  label: string
  caption: string
  alt: string
}

/** Real interior pages from Volume 3 (Connect & Combine), 1080×1920. */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/ndpKxCQUqs1dBS689tdSya/1-rotation-map-week19.jpg',
    label: 'Page A · Rotation Map',
    caption: 'Week 19, the whole class on one page: objective, four timed stations, game and cool-down.',
    alt: 'Volume 3 Week 19 Rotation Map: Cartwheel Across the Floor, with Floor, Bars, Beam and Vault stations of 8 minutes each',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eky4wtabFY8ohdvXUwChdz/2-skill-spotlight-week19.jpg',
    label: 'Page B · Skill Spotlight',
    caption: "The week's skill at three levels, with the top cue, the #1 error and its fix, and where to spot.",
    alt: 'Volume 3 Week 19 Skill Spotlight: cartwheel progression ladder with easier, on-target and harder levels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nSewsisuqVrjH5srJT1g3G/3-class-formula.jpg',
    label: 'The Class Formula',
    caption: 'Your slot is 30, 45 or 60 minutes? The minutes are already worked out.',
    alt: 'The Class Formula page: minutes per phase for Full 60, Medium 45 and Short 30 classes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sRthYzHUoZUyAH242NpMsc/4-quick-win-cartwheel.jpg',
    label: 'Quick Win',
    caption: 'One cue that fixes cartwheels. Kids can use it to check themselves.',
    alt: 'Quick Win page: hand, hand, foot, foot, the one cue that fixes cartwheels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8bRXyQhEcZ9otV7mciCuMN/5-games-handstands-cartwheels.jpg',
    label: 'Games that teach',
    caption: "5-minute games that train the week's shape and work as your warm-up.",
    alt: 'Games That Sneak In Handstands and Cartwheels: Wheelbarrow Races, Wall-Climb Count, Cartwheel the River and more',
  },
]
